import { motion } from "motion/react";
import { Separator } from "@/src/components/ui/separator";

export function CoachingPhilosophy() {
  return (
    <section className="py-24 bg-background">
      <div className="container mx-auto px-6 max-w-4xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="space-y-16"
        >
          {/* Main Heading & Intro */}
          <div className="space-y-8">
            <h2 className="text-4xl md:text-5xl font-serif text-primary leading-tight">
              Coaching in Personal and Professional Life
            </h2>
            <div className="space-y-6 text-lg text-muted-foreground leading-relaxed">
              <p>
                In an ever-evolving world with its fast pace and rising stress levels, finding your path in your personal and professional life can be extremely difficult.
              </p>
              <p>
                More often than not, people are forced to do tasks that do not necessarily fall into the scope of their natural talent. This is not only frustrating, but can be counterproductive, especially in a business setting.
              </p>
            </div>
          </div>

          <Separator className="bg-primary/10" />

          {/* History & Context */}
          <div className="space-y-10">
            <div className="inline-block px-4 py-1 rounded-full bg-secondary text-primary text-sm font-semibold tracking-widest uppercase">
              The Evolution of Coaching
            </div>
            <h3 className="text-3xl font-serif italic text-foreground">Coaching</h3>
            
            <div className="space-y-8 text-lg text-muted-foreground leading-relaxed">
              <p>
                With this in mind, more and more people are seeing the benefit of coaching and career guidance. Careers in Psychology reports that coaching has been a formal profession since the 1950’s.
              </p>
              <p>
                According to Therapy Today, coaching began as a discipline within psychology that focused on the benefits of talking therapy to improve wellness in the workplace. As the different disciplines developed and new discoveries were made, so did coaching.
              </p>
              
              {/* Stats Highlight */}
              <div className="bg-muted p-10 rounded-[2.5rem] border border-primary/5 shadow-sm">
                <p className="mb-8 font-medium text-foreground">Since the 1990’s the coaching phenomenon has taken the world by storm.</p>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
                  <div className="space-y-2">
                    <p className="text-4xl font-serif text-primary">1,500</p>
                    <p className="text-xs uppercase tracking-wider font-semibold opacity-70">ICF Members (1999)</p>
                  </div>
                  <div className="space-y-2">
                    <p className="text-4xl font-serif text-primary">17,000</p>
                    <p className="text-xs uppercase tracking-wider font-semibold opacity-70">Coaches (2013)</p>
                  </div>
                  <div className="space-y-2">
                    <p className="text-4xl font-serif text-primary">34,000+</p>
                    <p className="text-xs uppercase tracking-wider font-semibold opacity-70">Coaches Today</p>
                  </div>
                </div>
                <p className="mt-8 text-sm italic">Spanning across 139 countries worldwide.</p>
              </div>

              <p>
                The phenomenon took a little longer to reach developing countries, but is now alive, well, and very much needed in South Africa. But coaching can only yield results if the psychology of the individual is considered.
              </p>
            </div>
          </div>

          {/* The Iwantcoaching Difference */}
          <div className="bg-primary text-white p-10 md:p-16 rounded-[3.5rem] shadow-2xl relative overflow-hidden group">
            <div className="relative z-10 space-y-8">
              <h3 className="text-3xl md:text-4xl font-serif leading-tight">
                And this is where <span className="italic underline underline-offset-8 decoration-white/30">Iwantcoaching</span> comes in.
              </h3>
              <div className="space-y-6 text-primary-foreground/90 text-lg leading-relaxed">
                <p>
                  Iwantcoaching has been ahead of the curb since 2002 when we started to incorporate positive psychology, while drawing from years of training and corporate experience, to offer guidance for people and businesses who want to reach their full potential.
                </p>
                <p>
                  Our strategic business coaches will help you to identify your natural strengths and virtues and guide you to optimise it. Your self-awareness of your natural talents is the key to success on a personal and professional level.
                </p>
                <div className="pt-6 border-t border-white/10">
                  <p className="text-2xl font-serif italic text-white leading-snug">
                    "You are unique and you already have the tools to be successful, Iwantcoaching will help you to identify and discover these tools and guide you on how to develop and use them to reach your fullest potential."
                  </p>
                </div>
              </div>
            </div>
            
            {/* Decorative background elements */}
            <div className="absolute -top-24 -right-24 w-64 h-64 bg-white/5 rounded-full blur-3xl group-hover:bg-white/10 transition-colors duration-700" />
            <div className="absolute -bottom-24 -left-24 w-80 h-80 bg-black/10 rounded-full blur-3xl" />
          </div>
        </motion.div>
      </div>
    </section>
  );
}
